module.exports = __webpack_public_path__ + "img/IMG_1149_L_Wood.9c972d26.jpg";